import { authenticatedAxios } from "lib/actions/fetcher";
import { endpointsIssues } from "lib/actions/endpoints/endpointsIssues";

export async function issueDelete(projectId: number, issueId: string) {
  await authenticatedAxios.request({
    ...endpointsIssues.projectIssueDelete(projectId, issueId),
  });
}
